import React from 'react'
import { connect } from 'react-redux'
import * as Yup from 'yup'
import AuthForm from './AuthForm'
import {
  requiredStringValidator,
  emailValidator,
} from '../../../../../form-validation'
import { partnerHostLive, partnerHostStaging } from '../../../../../constants'
import { isMobile } from '../../../../../helpers'
import { resolvePostLoginUrl } from '../Account/PartnerDocumentRedirect'
const isMobileBrowser = isMobile()
const Host = window.location.hostname
const fields = [
  {
    name: 'email',
    label: 'EMAIL*',
    icon: 'account_circle',
  },
]

const validationSchema = Yup.object().shape({
  email: requiredStringValidator().concat(emailValidator()),
})

const initialValues = {
  email: '',
}

function LoginPartner(props) {
  const oldUrl =
    (props.location && props.location.state && props.location.state.oldUrl) ||
    (props.state && props.state.oldUrl) ||
    null
  if (props.isLoggedIn) {
    props.history.push(
      oldUrl
        ? resolvePostLoginUrl(oldUrl, props.partnerToken)
        : `${
            Host === partnerHostLive || Host === partnerHostStaging
              ? '/'
              : '/partner/'
          }driver/app/${props.partnerToken}/home-page`
    )
  }
  return (
    <>
      <div className='auth-page'>
        <div className='image-container-new-partner' />
        <div className='auth-container'>
          <AuthForm
            title='Log in'
            initialValues={initialValues}
            validationSchema={validationSchema}
            fields={fields}
            isLoginUser
            buttonLabel='Continue'
            submitStyle='login-btn'
            oldUrl={oldUrl}
          />
        </div>
      </div>
    </>
  )
}

const mapStateToProps = ({ auth, clientAuth }) => {
  const { isLoggedIn, partnerToken } = auth

  return { isLoggedIn, partnerToken }
}

export default connect(mapStateToProps, {})(LoginPartner)
